module.exports = __webpack_public_path__ + "assets/adpoly-facility-service-rooms-bulk-upload-template.ca1601bf.xlsx";